module.exports = __webpack_public_path__ + "static/img/exerciseBg.7807fa56.png";